/* Copyright Levelise Ltd 2025 - 2026 */
import { createContext, useState } from 'react';

const defaultValue = {
	selectedGSAVersion: 'all',
	selectedConsentProgress: '',
	selectedDirectionTab: 'import',
	selectedCaptureMethod: '',
	selectedProvider: '',
	selectedSmetsVersion: 'all',
	selectedMeasurementClass: '',
	filteredCustomerIdsByConsent: new Set(),
	filteredCustomerIdsByMetering: new Set(),
	filteredCustomerIds: [],

	setSelectedGSAVersion: () => {},
	setSelectedConsentProgress: () => {},
	setSelectedDirectionTab: () => {},
	setSelectedCaptureMethod: () => {},
	setSelectedProvider: () => {},
	setSelectedSmetsVersion: () => {},
	setSelectedMeasurementClass: () => {},
	setFilteredCustomerIdsByConsent: () => {},
	setFilteredCustomerIdsByMetering: () => {},
	setFilteredCustomerIds: () => {},
};

const FleetCustomersContext = createContext(defaultValue);

export default FleetCustomersContext;

export function FleetCustomersProvider({ children }) {
	const [selectedGSAVersion, setSelectedGSAVersion] = useState('all');
	const [selectedConsentProgress, setSelectedConsentProgress] = useState('');
	const [selectedDirectionTab, setSelectedDirectionTab] = useState('import');
	const [selectedCaptureMethod, setSelectedCaptureMethod] = useState('');
	const [selectedProvider, setSelectedProvider] = useState('');
	const [selectedMeasurementClass, setSelectedMeasurementClass] = useState('');
	const [selectedSmetsVersion, setSelectedSmetsVersion] = useState('all');
	const [filteredCustomerIds, setFilteredCustomerIds] = useState([]);
	const [filteredCustomerIdsByConsent, setFilteredCustomerIdsByConsent] = useState(new Set());
	const [filteredCustomerIdsByMetering, setFilteredCustomerIdsByMetering] = useState(new Set());

	return (
		<FleetCustomersContext.Provider
			value={{
				selectedGSAVersion,
				selectedConsentProgress,
				selectedDirectionTab,
				selectedCaptureMethod,
				selectedProvider,
				selectedMeasurementClass,
				selectedSmetsVersion,
				filteredCustomerIdsByConsent,
				filteredCustomerIdsByMetering,
				filteredCustomerIds,

				setSelectedGSAVersion,
				setSelectedConsentProgress,
				setSelectedDirectionTab,
				setSelectedCaptureMethod,
				setSelectedProvider,
				setSelectedMeasurementClass,
				setSelectedSmetsVersion,
				setFilteredCustomerIdsByConsent,
				setFilteredCustomerIdsByMetering,
				setFilteredCustomerIds,
			}}
		>
			{children}
		</FleetCustomersContext.Provider>
	);
}
